var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpMethodType, EnvironmentService, handleResponseWithExplicitErrorMessage } from "../../common";
import { createHttpRequest, createStandardHeaders } from '../utilities';
export class PhotoCaptureIntelligentReactivationUrlService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    photoCaptureGetIntelligentReactivationUrlData(coCode, contextId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1.0/apd/photocapture/companies/${coCode}/apd/coCode/${coCode}/contexts/${contextId}/reactivate-url`;
            const headers = createStandardHeaders();
            const request = createHttpRequest(uri, HttpMethodType.POST, headers);
            return this.fetchWrapper(request).then(response => handleResponseWithExplicitErrorMessage(response)
                .then(resolvedResponse => {
                return Promise.resolve(resolvedResponse);
            })
                .catch(error => {
                return Promise.reject(JSON.parse(error));
            }));
        });
    }
}
//# sourceMappingURL=PhotoCaptureIntelligentReactivationUrlService.js.map